import { Component, OnInit, ViewChild, Renderer2, DebugNode, ElementRef } from '@angular/core';
import { Registration } from '../Models/registration.model';
import { RegistrationService } from './registration.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
declare var $: any;

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  @ViewChild('RegistrationForm') RegistrationForm: NgForm;
  @ViewChild('divFormRow') divFormRow: ElementRef;
  data: Registration;
  boards: any;
  mediums: any;
  institutetypes: any;
  typeOfTrusts: any;
  dropDownData: any;
  offices: any;
  sections: any;
  responseData: any;
  id: any;
  TrusteeDetail: Array<any> = [];
  PrincipalDetail: Array<any> = [];
  OwnerDetail: Array<any> = [];
  hid_trusteeDetailID: any = -1;
  hid_principalDetailID: any = -1;
  hid_ownerDetailID: any = -1;
  hid_InfrastructureDetailID: any = -1;
  hid_EmployeeDetailID: any = -1;
  hid_EmployeeQualificationDetailID: any = -1;
  states: any;
  cities: any;
  types: any;
  locations: any;
  infrastructures: any;
  standardList: Array<any> = [];
  standards: Array<any> = [];
  designations: any;
  btnsubmittext = "Submit";
  DivisionDetail: Array<any> = [];
  visibleAquireDate: boolean = false;
  visibleAffiliation: boolean = false;
  SectionWiseStd: Array<any> = [];
  InfrastructureDetail: Array<any> = [];
  EmployeeDetail: Array<any> = [];
  EmployeeQualificationDetail: Array<any> = [];
  employeetypes: any;
  yearlist: any;
  yearid: any;
  qualifications: any;
  ClassroomDetail: Array<any> = [];
  standatalist: Array<any> = [];
  constructor(private service: RegistrationService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router, private rout: ActivatedRoute, private renderer: Renderer2) { }

  ngOnInit(): void {
    if (localStorage.length == 0) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
      this.fillRegistrationDetail();
  });
    this.data = new Registration();
    this.spinner.show();
    this.fillBoard();
    this.fillMediums();
    this.fillInstituteType();
    this.fillOffice();
    this.fillTypeOfTrust();
    this.fillSection();
    this.fillState();
    this.FillSchoolType();
    this.FillSchoolLocation();
    this.fillDesignation();
    this.fillYear();
    this.fillInfrastructure();
    this.fillEmployeeType();
    this.fillEmployeeQualificationType();

    if (this.rout.snapshot.paramMap.has('ID')) {
      this.data.HashCode = this.rout.snapshot.paramMap.get('ID');
      setTimeout(() => { this.fillRegistrationDetail(); }, 1000);
      this.btnsubmittext = "Update";
    } else {
      this.data.ID = 0;
      this.spinner.hide();
    }
    var dtToday = new Date();
    var month: string = (dtToday.getMonth() + 1).toString();
    var day: string = (dtToday.getDate()).toString();
    var year: string = (dtToday.getFullYear()).toString();
    if (parseInt(month) < 10)
      month = '0' + month.toString();
    if (parseInt(day) < 10)
      day = '0' + day.toString();
    var maxDate = year + '-' + month + '-' + day;
    $('#RegistrationDate').attr('max', maxDate);
    $('#AcquiredDate').attr('max', maxDate);
    $('#AffiliationNumberAcquireDate').attr('max', maxDate);
    if (this.data.HashCode != undefined || this.data.HashCode != "")
      this.data.RegistrationDate = maxDate;
  }
  
  fillBoard() {
    const data = {
    };
    this.service.fillBoard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.boards = this.dropDownData.dropdownlist;
        this.boards.splice(0, 1);
      });
  }

  fillMediums() {
    const data = {
      HashCode: ""
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.mediums.splice(0, 1);
        // this.data.Medium = 0;
      });
  }

  fillInstituteType() {
    const data = {
    };
    this.service.fillInstituteType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.institutetypes = this.dropDownData.dropdownlist;
        this.institutetypes.splice(0, 1);
      });
  }

  fillOffice() {
    const data = {
    };
    this.service.fillOffice(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.offices = this.dropDownData.dropdownlist;
        this.data.Office = 0;
      });
  }

  fillTypeOfTrust() {
    const data = {
    };
    this.service.fillTypeOfTrust(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.typeOfTrusts = this.dropDownData.dropdownlist;
        this.data.TypeOfTrust = 0;
      });
  }

  fillSection() {
    const data = {
    };
    this.service.fillSection(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.sections = this.dropDownData.Sectionlist;
        // this.data.Section = 0;
      });
  }

  fillState() {
    const data = {
    };
    this.service.fillState(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.states = this.dropDownData.dropdownlist;
        this.data.State = 0;
      });
  }

  fillCity() {
    const data = {
      stateID: this.data.State
    };
    this.service.fillCity(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.cities = this.dropDownData.dropdownlist;
        if (this.data.City == 0 || this.data.City == undefined)
          this.data.City = 0;
      });
  }

  FillSchoolType() {
    const data = {
    };
    this.service.fillSchoolType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.types = this.dropDownData.dropdownlist;
        this.data.SchoolType = 0;
      });
  }

  FillSchoolLocation() {
    const data = {
    };
    this.service.fillSchoolLocation(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.locations = this.dropDownData.dropdownlist;
        this.data.SchoolLocation = 0;
      });
  }

  fillDesignation() {
    const data = {
    };
    this.service.fillDesignation(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.designations = this.dropDownData.dropdownlist;
        this.data.DesignationID = 0;
      });
  }

  fillYear() {
    const data = {
    };
    this.service.fillYear(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.yearlist = this.dropDownData.dropdownlist;
        this.data.YearID = parseInt(localStorage.getItem("yearID"));
      });
  }

  fillInfrastructure() {
    const data = {
    };
    this.service.fillInfrastructure(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.infrastructures = this.dropDownData.dropdownlist;
        this.data.InfrastructureID = 0;
      });
  }

  fillEmployeeType() {
    const data = {
    };
    this.service.fillEmployeeType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.employeetypes = this.dropDownData.dropdownlist;
        this.data.EmployeeTypeID = 0;
        // console.log(this.dropDownData.dropdownlist);
      });
  }

  fillEmployeeQualificationType() {
    const data = {
    };
    this.service.fillEmployeeQualificationType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.qualifications = this.dropDownData.dropdownlist;
        this.data.QualificationID = 0;
      });
  }

  blockSpecialChar(e) {
    var k;
    document.all ? k = e.keyCode : k = e.which;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57) || k == 91 || k == 93 || k == 45 || k == 32 || k == 92 || k == 47);
  }

  resetStudCount() {
    this.data.playGroup = 0
    this.data.nursery = 0
    this.data.jrkg = 0
    this.data.srkg = 0
    this.data.std1 = 0
    this.data.std2 = 0
    this.data.std3 = 0
    this.data.std4 = 0
    this.data.std5 = 0
    this.data.std6 = 0
    this.data.std7 = 0
    this.data.std8 = 0
    this.data.std9 = 0
    this.data.std10 = 0
    this.data.std11sci = 0
    this.data.std12sci = 0
    this.data.std11com = 0
    this.data.std12com = 0
    this.data.std11arts = 0
    this.data.std12arts = 0
  }
  // viewStd(i){
  //   var stdlist = this.sections[i]["StandardList"];
  //   var value = $("#chksection" + i).prop("checked");
  //   if (value) {
  //     for (var j = 0; j < stdlist.length; j++) {
  //       this.SectionWiseStd[this.SectionWiseStd.length] = stdlist[j];
  //     }
  //   } else {
  //     for (var j = 0; j < this.SectionWiseStd.length; j++) {
  //       if (this.SectionWiseStd[j]["index"] == i) {
  //         this.SectionWiseStd.splice(j, 1);
  //         j = -1;
  //       }
  //     }
  //   }
  //   console.log(this.SectionWiseStd)
  // }

  displayAffiliation() {
    var j = $('#chkBoard' + 1).is(":checked");
    if (j) {
      this.visibleAffiliation = true;
    } else {
      this.visibleAffiliation = false;
      this.data.AffiliationNumberAcquireDate = null;
      this.data.AffiliationNumber = null;
    }
  }

  displayAquireDate() {
    this.visibleAquireDate = false;
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).is(":checked");
      if (j == true && parseInt(this.sections[i]["value"]) > 2) {
        this.visibleAquireDate = true;
      }
    }
  }

  validateClassroomDetail() {
    this.ClassroomDetail = [];
    for (var x = 0; x < this.data.NoOfClassroom; x++) {
      var classroomname = $("#classroomname" + x).val();
      var classroomsize = $("#classroomsize" + x).val();
      if (classroomname == undefined || classroomname.trim().length <= 0) {
        this.toastr.error("classroom name is requied")
        return false;
      }
      if (classroomsize == undefined || classroomsize.toString().trim().length == 0) {
        this.toastr.error("classroom size is requied")
        return false;
      }
      this.ClassroomDetail.push({ "ClassroomName": classroomname, "ClassroomSize": classroomsize })
    }
    this.data.ClassroomDetail = this.ClassroomDetail;
    return true;
  }

  fillRegistrationDetail() {
    this.spinner.show();
    const data = {
      HashCode: this.data.HashCode,
      YearID: parseInt(localStorage.getItem("yearID"))
    };
    this.service.fillRegistrationDetail(data)
      .subscribe(data => {
        this.spinner.hide();
        this.responseData = data;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
          return
        }

        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/registration']);
          return
        }
        else {
          this.data = this.responseData;
          this.fillCity();
          //this.fillInfrastructure();
          //this.fillEmployeeType();

          for (var i = 0; i < this.boards.length; i++) {
            if (this.data.Board.includes(this.boards[i]["value"])) {
              $('#chkBoard' + i).prop("checked", true);
            }
            if (this.responseData.hasRequest > 0)
              $('#chkBoard' + i).prop("disabled", true);
          }
          for (var i = 0; i < this.mediums.length; i++) {
            if (this.data.Medium.includes(this.mediums[i]["value"])) {
              $('#chkmedium' + i).prop("checked", true);
            }
            if (this.responseData.hasRequest > 0)
              $('#chkmedium' + i).prop("disabled", true);
          }
          for (var i = 0; i < this.institutetypes.length; i++) {
            if (this.data.InstituteTypeID.includes(this.institutetypes[i]["value"])) {
              $('#chkinstitute' + i).prop("checked", true);
              this.fillCourse();
            }
            if (this.responseData.hasRequest > 0)
              $('#chkinstitute' + i).prop("disabled", true);
          }
          for (var i = 0; i < this.sections.length; i++) {
            if (this.data.Section.includes(this.sections[i]["value"])) {
              $('#chksection' + i).prop("checked", true);
              //this.fillStd();
              this.fillCourse();
            }
            if (this.responseData.hasRequest > 0)
            $('#chksection' + i).prop("disabled", true);
          }
          for (var i = 0; i < this.institutetypes.length; i++) {
            if (this.data.InstituteTypeID.includes(this.institutetypes[i]["value"])) {
              $('#chkinstitute' + i).prop("checked", true);
              //this.fillStd();
              this.fillCourse();
            }
            //if (this.responseData.hasRequest > 0)
            // $('#chksection' + i).prop("disabled", true);
          }
          var f = 0;
          for (var i = 0; i < this.sections.length; i++) {
            if (this.data.Section.includes(this.sections[i]["value"])) {
              $('#chksection' + i).prop("checked", true);
              if (parseInt(this.sections[i]["value"]) > 2) {
                f++;
              }
            }
          }
          this.displayAffiliation();
          if (f > 0) {
            this.visibleAquireDate = true;
          }
          this.spinner.show();
          //this.setSudCount(); this.spinner.hide();
          this.standatalist = this.data.StandardDetails;
          setTimeout(() => { this.setSudCount(); this.fillClassRooms(); this.spinner.hide(); }, 500);
          this.data.DesignationID = 0;
          this.TrusteeDetail = this.data.TrusteeDetail;
          this.PrincipalDetail = this.data.PrincipalDetail;
          this.OwnerDetail = this.data.OwnerDetail;
          this.InfrastructureDetail = this.data.InfrastructureDetail;
          this.EmployeeDetail = this.data.EmployeeDetail;
          this.EmployeeQualificationDetail = this.data.EmployeeQualificationDetail;
          this.data.EmployeeTypeID = 0;
          this.data.InfrastructureID = 0;
          this.data.QualificationID = 0;
          if (!this.responseData.userRightsStatus) {
            this.toastr.error(this.responseData.message);
            $("#btnsubmit").css("display", "none");
            //this.router.navigate(['/aciadmin']);
            return;
          }
          else {
            $("#btnsubmit").css("display", "block");
          }
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  fillCourse() {
    this.standardList = [];
    this.standards = [];
    // this.documentList =[];
    //var stdlist = this.sections[i]["StandardList"];
    for (var q = 0; q < this.mediums.length; q++) {
      var m = $("#chkmedium" + q).prop("checked");
      if (m) {
        for (var g = 0; g < this.institutetypes.length; g++) {
          var c = $("#chkinstitute" + g).prop("checked");
          var insval =  $("#chkinstitute" + g).val();
          if (c) {
            for (var p = 0; p < this.sections.length; p++) {
              var value = $("#chksection" + p).prop("checked");
              if (value) {
                var stdlist = this.sections[p]["StandardList"];
                for (var j = 0; j < stdlist.length; j++) {
                  var newtext = stdlist[j]["text"];
                  var mediumtext = this.mediums[q]["text"];
                  var instext = this.institutetypes[g]["text"];
                  if(insval == stdlist[j]["instituteTypeID"]){
                  this.standards[this.standards.length] = { ...stdlist[j] };
                  this.standards[this.standards.length - 1]["MediumID"] = this.mediums[q]["value"];
                  this.standards[this.standards.length - 1]["medium"] = this.mediums[q]["text"];
                  this.standards[this.standards.length - 1]["text"] = newtext + " - " + mediumtext + " Medium" + " - " + instext;
                  this.standards[this.standards.length - 1]["StandardID"] = stdlist[j]["value"];
                  this.standards[this.standards.length - 1]["InstituteTypeID"] = stdlist[j]["instituteTypeID"];
                  for (var k = 1; k <= stdlist[j]["noofyear"]; k++) {
                    var displayyear = this.displayyear(k);
                    this.standardList[this.standardList.length] = { ...this.standards[this.standards.length - 1] };
                    this.standardList[this.standardList.length - 1]["text"] = this.standardList[this.standardList.length - 1]["text"] + " (" + displayyear + " " + stdlist[j]["coursetype"] + ")";
                    this.standardList[this.standardList.length - 1]["year"] = k;
                  }
                }
                }
              }
            }
          }
        }
      }
    }
    for (var l = 0; l < this.standards.length; l++) {
      $("#chkStd" + l).prop("checked", false);
    }
    this.removeStd();
  }

  removeStd() {
    var c = 0;
    for (var l = 0; l < this.standards.length; l++) {
      var chkstd = $("#chkStd" + l).prop("checked");
      if (chkstd) {
        c++;
      }
    }
    if (c == 0) {
      this.standardList = [];
    }
  }

  validatestudcount() {
    for (var x = 0; x < this.standardList.length; x++) {
      var j = $('#std' + x + '_' + x).val();
      if (j != "" && j > 0) {
        this.data[this.standardList[x]["standard"]] = j;
        for (var a = 0; a < j; a++) {
          var divname = $("#division" + this.standardList[x]["value"] + "_" + a + "_" + x + "_" + this.standardList[x]["year"]).val();
          var studCount = $("#studCount" + this.standardList[x]["value"] + "_" + a + "_" + x + "_" + this.standardList[x]["year"]).val();
          if (divname == undefined || divname.trim().length <= 0) {
            this.toastr.error("Division name is requied for all course")
            return false;
          }
          if (studCount == undefined || studCount.toString().trim().length <= 0 || studCount.toString().trim() == "0") {
            this.toastr.error("Student is requied for all division")
            return false;
          }
        }
      }
      else {
        this.toastr.error("Enter no. of student for all Course");
        return false;
      }
    }
    this.DivisionDetail = [];
    for (var x = 0; x < this.standardList.length; x++) {
      var j = $('#std' + x + '_' + x).val();
      if (j != "" && j > 0) {
        // this.data[this.standardList[x]["standard"]] = j;
        // this.standardList[x]["DivisionCount"] = j;
        // this.standardList[x]["DivisionDetail"] = null;
        for (var a = 0; a < j; a++) {
          var divname = $("#division" + this.standardList[x]["value"] + "_" + a + "_" + x + "_" + this.standardList[x]["year"]).val();
          var studCount = $("#studCount" + this.standardList[x]["value"] + "_" + a + "_" + x + "_" + this.standardList[x]["year"]).val();
          this.DivisionDetail.push({ "StandardID": this.standardList[x]["value"], "Year": this.standardList[x]["year"], "MediumID": this.standardList[x]["MediumID"], "DivisionName": divname, "StudentCount": studCount })
        }
        // this.standardList[x]["DivisionDetail"] = this.DivisionDetail;
      }
    }

    this.data.StandardDetails = this.DivisionDetail;
    return true;
  }

  onSubmit(data) {
    this.resetStudCount();
    this.data.Board = "";
    for (var i = 0; i < this.boards.length; i++) {
      var j = $('#chkBoard' + i).is(":checked");
      if (j == true) {
        if (this.data.Board == "")
          this.data.Board += ",";
        this.data.Board += this.boards[i]["value"] + ",";
      }
    }

    this.data.Medium = "";
    for (var i = 0; i < this.mediums.length; i++) {
      var j = $('#chkmedium' + i).is(":checked");
      if (j == true) {
        if (this.data.Medium == "")
          this.data.Medium += ",";
        this.data.Medium += this.mediums[i]["value"] + ",";
      }
    }

    this.data.Section = "";
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).is(":checked");
      if (j == true) {
        if (this.data.Section == "")
          this.data.Section += ",";
        this.data.Section += this.sections[i]["value"] + ",";
      }
    }

    this.data.InstituteTypeID = "";
    for (var i = 0; i < this.institutetypes.length; i++) {
      var j = $('#chkinstitute' + i).is(":checked");
      if (j == true) {
        if (this.data.InstituteTypeID == "")
          this.data.InstituteTypeID += ",";
        this.data.InstituteTypeID += this.institutetypes[i]["value"] + ",";
      }
    }

    if (this.data.Board == "" || this.data.Medium == "" || this.data.Section == "" || this.data.InstituteTypeID == "") {
      return;
    }
    var f = 0;
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).is(":checked");
      if (j == true) {
        if (parseInt(this.sections[i]["value"]) > 2) {
          f++;
          break;
        }
      }
    }
    if (f == 0) {
      this.data.AcquiredDate = null;
    }
    if (data.Medium == 0 || data.Medium == undefined || data.TypeOfTrust == 0 || data.TypeOfTrust == undefined
      || data.Section == 0 || data.Section == undefined || data.InstituteTypeID == 0 || data.InstituteTypeID == undefined || data.SchoolLocation == 0
      || data.SchoolLocation == undefined) {
      //this.toastr.error('Please fill all details');
      return;
    }
    if (this.TrusteeDetail == undefined || this.TrusteeDetail.length == 0) {
      this.toastr.error("Add atleast one trustee detail");
      return;
    }
    if (this.PrincipalDetail == undefined || this.PrincipalDetail.length == 0) {
      this.toastr.error("Add atleast one principal detail");
      return;
    }
    // if (this.InfrastructureDetail == undefined || this.InfrastructureDetail.length == 0) {
    //   this.toastr.error("Add atleast one infrastructure detail");
    //   return;
    // }
    if (this.EmployeeDetail == undefined || this.EmployeeDetail.length == 0) {
      this.toastr.error("Add atleast one employee detail");
      return;
    }
    if (this.EmployeeQualificationDetail == undefined || this.EmployeeQualificationDetail.length == 0) {
      this.toastr.error("Add atleast one employee qualification detail detail");
      return;
    }

    this.data.TrusteeDetail = this.TrusteeDetail;
    this.data.PrincipalDetail = this.PrincipalDetail;
    this.data.InfrastructureDetail = this.InfrastructureDetail;
    this.data.EmployeeDetail = this.EmployeeDetail;
    this.data.EmployeeQualificationDetail = this.EmployeeQualificationDetail;
    this.data.YearID = Number(localStorage.getItem("YearID"));
    //this.standard = []
    // if (this.standardList.length == 0) {
    //   this.toastr.error("Enter no. of division for all standard");
    //   return
    // }
    var z = this.validatestudcount();
    if (z == false) {
      return;
    }
    // for (var x = 0; x < this.standardList.length; x++) {
    //   var j = $('#std' + x).val();
    //   if (j != "" && j > 0)
    //     this.data[this.standardList[x]["standard"]] = j;
    //   else {
    //     this.toastr.error("Enter no. of student for all standard");
    //     return
    //   }
    // }
    // if (this.OwnerDetail == undefined || this.OwnerDetail.length == 0) {
    //   this.toastr.error("Add atleast one owner detail");
    //   return;
    // }
    // if (this.data.PendingSalaryIncrementAmount == undefined || this.data.PendingSalaryIncrementAmount <= 0) {
    //   this.toastr.error("Amount must be greater then zero");
    //   $('#PendingSalaryIncrementAmount').focus();//this.data.PendingSalaryIncrementAmount.
    //   return;
    // }
    // if (this.data.DepreciationAmount == undefined || this.data.DepreciationAmount <= 0) {
    //   this.toastr.error("Amount must be greater then zero");
    //   $('#DepreciationAmount').focus();//this.data.PendingSalaryIncrementAmount.
    //   return;
    // }

    var z = this.validateClassroomDetail();
    if (z == false) {
      return;
    }

    this.data.OwnerDetail = this.OwnerDetail;
    if (this.RegistrationForm.valid) {
      this.spinner.show();
      this.service.saveRegistrationDetails(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (!this.responseData.userRightsStatus) {
            this.toastr.error(this.responseData.message);
            //this.router.navigate(['/aciadmin']);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.spinner.hide();
            this.toastr.success(this.responseData.message);
            this.RegistrationForm.resetForm();
            this.resetDropDown();
            this.redirectToList()
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    } else {
      this.toastr.error('Please fill all details');
      const invalid = [];
      const controls = this.RegistrationForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
    }
  }

  setSudCount() {
    this.spinner.show();
    var std = 0;
    this.standardList = []

    // for (var k = 0; k < this.sections.length; k++) {
    for (var l = 0; l < this.standards.length; l++) {
      $("#chkStd" + l).prop("checked", false);
      for (var n = 0; n < this.data.StandardDetails.length; n++) {
        if (std != this.data.StandardDetails[n]["StandardID"]) {
          if (this.standards[l]["value"] == this.data.StandardDetails[n]["StandardID"]
          && this.standards[l]["MediumID"] == this.data.StandardDetails[n]["MediumID"]) {
            std = this.data.StandardDetails[n]["StandardID"]

            $("#chkStd" + l).prop("checked", true);
            for (var k = 1; k <= this.standards[l]["noofyear"]; k++) {
              var displayyear = this.displayyear(k);
              this.standardList[this.standardList.length] = { ...this.standards[l] };
              this.standardList[this.standardList.length - 1]["text"] = this.standardList[this.standardList.length - 1]["text"] + " (" + displayyear + " " + this.standards[l]["coursetype"] + ")";
              this.standardList[this.standardList.length - 1]["year"] = k;
            }
          }
        }
      }
    }

    setTimeout(() => {
      std = 0;
      var mediumid = 0;
      this.standatalist = [];

      // for (var q = 0; q < this.standardList.length; q++) {
      //   debugger;
      //   for (var n = 0; n < this.data.StandardDetails.length; n++) {
      //     if (this.standardList[q]["StandardID"] == this.data.StandardDetails[n]["StandardID"] &&
      //       this.standardList[q]["year"] == this.data.StandardDetails[n]["Year"]
      //       && this.data.StandardDetails[n]["MediumID"] == 0 ) {
      //       //this.data.StandardDetails[n]["MediumID"] = this.standardList[q]["MediumID"];
      //     }
      //   }
      // }

      for (var j = 0; j < this.standardList.length; j++) {
        var c = 0;
        var d = 0;

        for (var m = 0; m < this.data.StandardDetails.length; m++) {
          if (this.standardList[j]["StandardID"] == this.data.StandardDetails[m]["StandardID"] &&
            this.standardList[j]["year"] == this.data.StandardDetails[m]["Year"]
            && this.standardList[j]["MediumID"] == this.data.StandardDetails[m]["MediumID"]) {
            c++;
          }
        }
        //$("#std" + j + "_" + j).val(this.data.StandardDetails[m]["DivisionName"]);
        $("#std" + j + "_" + j).val(c);
        this.fillDiv(this.standardList[j]["value"], j, this.standardList[j]["year"]);
        var p = 0;
        for (var k = 0; k < this.data.StandardDetails.length; k++) {
          //debugger;
          if (this.standardList[j]["StandardID"] == this.data.StandardDetails[k]["StandardID"] &&
            this.standardList[j]["year"] == this.data.StandardDetails[k]["Year"] && this.standardList[j]["MediumID"] == this.data.StandardDetails[k]["MediumID"]) {
            $("#division" + this.standardList[j]["StandardID"] + "_" + p + '_' + j + "_" + this.standardList[j]["year"]).val(this.data.StandardDetails[k]["DivisionName"]);
            $("#studCount" + this.standardList[j]["StandardID"] + "_" + p + '_' + j + "_" + this.standardList[j]["year"]).val(this.data.StandardDetails[k]["StudentCount"]);

            p++;
          }
        }

      }

    }, 500);
  }

  fillStd() {
    this.standardList = [];
    this.standards = [];
    // this.documentList =[];
    //var stdlist = this.sections[i]["StandardList"];
    for (var q = 0; q < this.mediums.length; q++) {
      var m = $("#chkmedium" + q).prop("checked");
      if (m) {
        for (var p = 0; p < this.sections.length; p++) {
          var value = $("#chksection" + p).prop("checked");
          if (value) {
            var stdlist = this.sections[p]["StandardList"];
            for (var j = 0; j < stdlist.length; j++) {
              var newtext = stdlist[j]["text"];
              var mediumtext = this.mediums[q]["text"];

              this.standards[this.standards.length] = { ...stdlist[j] };
              this.standards[this.standards.length - 1]["MediumID"] = this.mediums[q]["value"];
              this.standards[this.standards.length - 1]["medium"] = this.mediums[q]["text"];
              this.standards[this.standards.length - 1]["text"] = newtext + " - " + mediumtext + " Medium";
              this.standards[this.standards.length - 1]["StandardID"] = stdlist[j]["value"];
              this.standards[this.standards.length - 1]["CourseType"] = stdlist[j]["coursetype"];
              for (var k = 1; k <= stdlist[j]["noofyear"]; k++) {
                // console.log(q);
                var displayyear = this.displayyear(k);
                this.standardList[this.standardList.length] = { ...this.standards[this.standards.length - 1] };
                this.standardList[this.standardList.length - 1]["text"] = this.standardList[this.standardList.length - 1]["text"] + " (" + displayyear + " " + stdlist[j]["coursetype"] + " )";
                this.standardList[this.standardList.length - 1]["year"] = k;
              }
              // this.documentList[this.documentList.length] = { ...stdlist[j] };;
              // this.documentList[this.documentList.length - 1]["ViewURL"] = "assets/images/no-image.jpg";
              // this.documentList[this.documentList.length - 1]["downloadURL"] = "assets/images/no-image.jpg";
              // this.documentList[this.documentList.length - 1]["StandardID"] = stdlist[j]["value"];
              // this.documentList[this.documentList.length - 1]["MediumID"] = this.mediums[q]["value"];
              // this.documentList[this.documentList.length - 1]["text"] = newtext + " - " + mediumtext + " Medium";
            }
          }
        }
      }
    }
  }

  manageRegDoc(i, text, mediumID, sectionID, stdID) {
    this.spinner.show();
    var c = $("#chkStd" + i).prop("checked");
    if (c) {
      for (var j = 0; j < this.sections.length; j++) {
        if (this.sections[j]["value"] == sectionID) {
          var stdList = this.sections[j]["StandardList"];
          break;
        }
      }
      for (var j = 0; j < stdList.length; j++) {
        if (stdList[j]["value"] == stdID) {
          for (var k = 1; k <= stdList[j]["noofyear"]; k++) {
            this.standardList[this.standardList.length] = { ...stdList[j] };
            // this.standardList[this.standardList.length - 1]["ViewURL"] = "assets/images/no-image.jpg";
            // this.standardList[this.standardList.length - 1]["downloadURL"] = "assets/images/no-image.jpg";
            var displayyear = this.displayyear(k);
            this.standardList[this.standardList.length - 1]["StandardID"] = stdList[j]["value"];
            this.standardList[this.standardList.length - 1]["text"] = text + " (" + displayyear + " " + stdList[j]["coursetype"] + ")";
            this.standardList[this.standardList.length - 1]["MediumID"] = mediumID;
            this.standardList[this.standardList.length - 1]["year"] = k;
          }
          break;
        }
      }
    }
    else {
      for (var j = 0; j < this.standardList.length; j++) {
        if (this.standardList[j]["StandardID"] == stdID && this.standardList[j]["MediumID"] == mediumID) {
          this.standardList.splice(j, 1);
          j--;
        }
      }
    }
    this.spinner.hide();
  }

  async fillDiv(stdid, i, year) {

    var val = $("#std" + i + "_" + i).val();
    //$("#divlist" + stdid).empty();
    $("#divlist" + stdid + "_" + i + "_" + year).html('');
    if (val != "0" && val != "" && parseInt(val) > 0) {
      this.spinner.show();
      for (var j = 0; j < val; j++) {
        var t: string;
        if (j == 0) {
          t = '<div class="p-2 m-2" style="border: 1px solid black"> ';
        }
        t += '<div class="row mt-2"> ' +
          '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
          ' <label><b>Division name</b><span class="text-danger">*</span></label> ' +
          ' <input name="division' + stdid + '_' + j + '_' + i + '_' + year + '" id="division' + stdid + '_' + j + '_' + i + '_' + year + '" autocomplete="off" class="form-control" type="text" placeholder="Enter division" maxlength="50"  /> ' +
          '</div>' +
          '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
          ' <label><b>Student count</b><span class="text-danger">*</span></label> ' +
          ' <input type="text" class="form-control" name="studCount' + stdid + '_' + j + '_' + i + '_' + year + '" autocomplete="off" id="studCount' + stdid + '_' + j + '_' + i + '_' + year + '"  placeholder="Enter student count"  maxlength="4" /> ' +
          '</div>' +
          '</div>';
      }
      // t +='<div class="row mt-2">';
      // t +='<div class="form-group col-lg-4 col-md-12 col-12">';
      // t +='<label><b>Total :</b></label><label #studcount' + stdid + '_' + year + ' id="studcount' + stdid + '_' + year + '" value="0"></label>';
      // t +='</div>';
      // t +='</div>';
      t += '</div>';
      // console.log("append",t);
      $("#divlist" + stdid + "_" + i + "_" + year).append(t);
      this.spinner.hide();
    }
  }

  totalcount() {
    console.log("calling...");
    //console.log($('#studcount' + stdid + '_' + j + '_' + year).val);
  }

  fillClassRooms() {
    if (this.data.NoOfClassroom > 0) {
      $("#divClassRoom").html('');
      this.spinner.show();
      for (var j = 0; j < this.data.NoOfClassroom; j++) {
        var t: string;
        if (j == 0) {
          t = '<div class="p-2 m-2" style="border: 1px solid black"> ';
        }
        var roomname = "";
        var roomsize = "";
        if (this.data.ClassroomDetail != undefined && this.data.ClassroomDetail[j] != undefined) {
          if (this.data.ClassroomDetail[j]["ClassroomName"] != undefined)
            roomname = this.data.ClassroomDetail[j]["ClassroomName"]

          if (this.data.ClassroomDetail[j]["ClassroomSize"] != undefined)
            roomsize = this.data.ClassroomDetail[j]["ClassroomSize"]
        }
        t += '<div class="row mt-2"> ' +
          '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
          ' <label><b>Classroom name</b><span class="text-danger">*</span></label> ' +
          ' <input name="classroomname' + j + '" id="classroomname' + j + '" autocomplete="off" class="form-control" type="text" value="' + roomname + '" placeholder="Enter classroom name" maxlength="50"  /> ' +
          '</div>' +
          '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
          ' <label><b>Classroom size (Format : Length x Width)</b><span class="text-danger">*</span></label> ' +
          ' <input type="text" class="form-control" name="classroomsize' + j + '" autocomplete="off" id="classroomsize' + j + '" value="' + roomsize + '" placeholder="Enter classroom size (Format : Length x Width)"  maxlength="15" /> ' +
          '</div>' +
          '</div>';
      }
      t += '</div>';
      $("#divClassRoom").append(t);
      this.spinner.hide();
    }
  }

  addTrustee() {
    if (this.data.TrusteeName == undefined || this.data.TrusteeName.trim().length == 0) {
      this.toastr.error("Enter Trustee's Name");
      return
    }
    if (this.data.TrusteeAddress == undefined || this.data.TrusteeAddress.trim().length == 0) {
      this.toastr.error("Enter Trustee Address");
      return
    }
    if (this.data.TrusteeMobileNo == undefined || this.data.TrusteeMobileNo.length != 10) {
      this.toastr.error("Enter valid mobile no");
      return
    }
    if (this.data.TrusteeMailID == undefined) {
      this.toastr.error("Enter email id");
      return
    }
    var pattern = "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";
    if (!this.data.TrusteeMailID.match(pattern)) {
      this.toastr.error("Enter valid email id");
      return
    }
    if (parseInt(this.hid_trusteeDetailID) >= 0) {
      this.TrusteeDetail[this.hid_trusteeDetailID] = {
        "TrusteeName": this.data.TrusteeName.trim(), "TrusteeAddress": this.data.TrusteeAddress.trim()
        , "TrusteeMobileNo": this.data.TrusteeMobileNo.trim(), "TrusteeMailID": this.data.TrusteeMailID.trim()
      }
    }
    else {
      for (var i = 0; i < this.TrusteeDetail.length; i++) {
        if (this.data.TrusteeName.trim() == this.TrusteeDetail[i]["TrusteeName"]) {
          this.toastr.error("Trustee's Name already exists");
          return
        }
        if (this.data.TrusteeMobileNo.trim() == this.TrusteeDetail[i]["TrusteeMobileNo"]) {
          this.toastr.error("Mobile No already exists");
          return
        }
        if (this.data.TrusteeMailID.trim() == this.TrusteeDetail[i]["TrusteeMailID"]) {
          this.toastr.error("Trustee's Mail ID already exists");
          return
        }
      }
      this.TrusteeDetail[this.TrusteeDetail.length] = {
        "TrusteeName": this.data.TrusteeName.trim(), "TrusteeAddress": this.data.TrusteeAddress.trim()
        , "TrusteeMobileNo": this.data.TrusteeMobileNo.trim(), "TrusteeMailID": this.data.TrusteeMailID.trim()
      }
    }
    this.clearTrustee();
  }
  editTrustee(i) {
    this.hid_trusteeDetailID = i;
    this.data.TrusteeName = this.TrusteeDetail[i]["TrusteeName"];
    this.data.TrusteeAddress = this.TrusteeDetail[i]["TrusteeAddress"];
    this.data.TrusteeMobileNo = this.TrusteeDetail[i]["TrusteeMobileNo"];
    this.data.TrusteeMailID = this.TrusteeDetail[i]["TrusteeMailID"];
  }
  deleteTrustee(i) {
    this.TrusteeDetail.splice(parseInt(i), 1);
  }
  clearTrustee() {
    this.hid_trusteeDetailID = "-1";
    this.data.TrusteeName = "";
    this.data.TrusteeAddress = "";
    this.data.TrusteeMobileNo = "";
    this.data.TrusteeMailID = "";
  }
  addPrincipal() {
    if (this.data.DesignationID == undefined || this.data.DesignationID == 0) {
      this.toastr.error("Select Designation");
      return
    }
    if (this.data.PrincipalName == undefined || this.data.PrincipalName.trim().length == 0) {
      this.toastr.error("Enter Principal's Name");
      return
    }
    if (this.data.PrincipalMobileNo == undefined || this.data.PrincipalMobileNo.length != 10) {
      this.toastr.error("Enter valid mobile no");
      return
    }
    if (this.data.PrincipalMailID == undefined) {
      this.toastr.error("Enter email id");
      return
    }
    var pattern = "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";
    if (!this.data.PrincipalMailID.match(pattern)) {
      this.toastr.error("Enter valid email id");
      return
    }
    var desiname = null;
    for (var i = 0; i < this.designations.length; i++) {
      if (this.data.DesignationID == this.designations[i]["value"]) {
        desiname = this.designations[i]["text"];
        break;
      }
    }
    if (parseInt(this.hid_principalDetailID) >= 0) {
      this.PrincipalDetail[this.hid_principalDetailID] = {
        "PrinDesignation": desiname,
        "DesignationID": this.data.DesignationID,
        "PrincipalName": this.data.PrincipalName.trim(), "PrincipalMobileNo": this.data.PrincipalMobileNo.trim()
        , "PrincipalMailID": this.data.PrincipalMailID.trim()
      }
    }
    else {
      for (var i = 0; i < this.PrincipalDetail.length; i++) {
        if (this.data.PrincipalName.trim() == this.PrincipalDetail[i]["PrincipalName"]) {
          this.toastr.error("Principal's Name already exists");
          return
        }
        if (this.data.PrincipalMobileNo.trim() == this.PrincipalDetail[i]["PrincipalMobileNo"]) {
          this.toastr.error("Mobile No already exists");
          return
        }
        if (this.data.PrincipalMailID.toLowerCase().trim() == this.PrincipalDetail[i]["PrincipalMailID"].toLowerCase()) {
          this.toastr.error("Principal's Mail ID already exists");
          return
        }
      }
      this.PrincipalDetail[this.PrincipalDetail.length] = {
        "PrinDesignation": desiname,
        "DesignationID": this.data.DesignationID,
        "PrincipalName": this.data.PrincipalName.trim(), "PrincipalMobileNo": this.data.PrincipalMobileNo.trim()
        , "PrincipalMailID": this.data.PrincipalMailID.trim()
      }
    }
    this.clearPrincipal();
  }
  editPrincipal(i) {
    this.hid_principalDetailID = i;
    this.data.DesignationID = this.PrincipalDetail[i]["DesignationID"];
    this.data.PrincipalName = this.PrincipalDetail[i]["PrincipalName"];
    this.data.PrincipalMobileNo = this.PrincipalDetail[i]["PrincipalMobileNo"];
    this.data.PrincipalMailID = this.PrincipalDetail[i]["PrincipalMailID"];
  }
  deletePrincipal(i) {
    this.PrincipalDetail.splice(parseInt(i), 1);
  }
  clearPrincipal() {
    this.hid_principalDetailID = "-1";
    this.data.DesignationID = 0;
    this.data.PrincipalName = "";
    this.data.PrincipalMobileNo = "";
    this.data.PrincipalMailID = "";
  }
  addOwner() {
    if (this.data.OwnerName == undefined || this.data.OwnerName.trim().length == 0) {
      this.toastr.error("Enter owner's name");
      return
    }
    if (this.data.OwnerMobileNo == undefined || this.data.OwnerMobileNo.length != 10) {
      this.toastr.error("Enter valid mobile no");
      return
    }
    if (this.data.OwnerMailID == undefined) {
      this.toastr.error("Enter email id");
      return
    }
    var pattern = "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";
    if (!this.data.OwnerMailID.match(pattern)) {
      this.toastr.error("Enter valid email id");
      return
    }
    if (parseInt(this.hid_ownerDetailID) >= 0) {
      this.OwnerDetail[this.hid_ownerDetailID] = {
        "OwnerName": this.data.OwnerName.trim(), "OwnerMobileNo": this.data.OwnerMobileNo.trim()
        , "OwnerMailID": this.data.OwnerMailID.trim()
      }
    }
    else {
      for (var i = 0; i < this.OwnerDetail.length; i++) {
        if (this.data.OwnerName.trim() == this.OwnerDetail[i]["OwnerName"]) {
          this.toastr.error("Owner's Name already exists");
          return
        }
        if (this.data.OwnerMobileNo.trim() == this.OwnerDetail[i]["OwnerMobileNo"]) {
          this.toastr.error("Owner's Mobile No already exists");
          return
        }
        if (this.data.OwnerMailID.trim() == this.OwnerDetail[i]["OwnerMailID"]) {
          this.toastr.error("Owner's Mail ID already exists");
          return
        }
      }
      this.OwnerDetail[this.OwnerDetail.length] = {
        "OwnerName": this.data.OwnerName.trim(), "OwnerMobileNo": this.data.OwnerMobileNo.trim()
        , "OwnerMailID": this.data.OwnerMailID.trim()
      }
    }
    this.clearOwner();
  }
  clearOwner() {
    this.hid_ownerDetailID = "-1";
    this.data.OwnerName = "";
    this.data.OwnerMobileNo = "";
    this.data.OwnerMailID = "";
  }
  editOwner(i) {
    this.hid_ownerDetailID = i;
    this.data.OwnerName = this.PrincipalDetail[i]["OwnerName"];
    this.data.OwnerMobileNo = this.PrincipalDetail[i]["OwnerMobileNo"];
    this.data.OwnerMailID = this.PrincipalDetail[i]["OwnerMailID"];
  }
  deleteOwner(i) {
    this.OwnerDetail.splice(parseInt(i), 1);
  }

  addEmployeeDetail() {
    if (this.data.EmployeeTypeID == undefined || this.data.EmployeeTypeID == 0) {
      this.toastr.error("Select employee category");
      return
    }

    if (this.data.TotalPermanentSalary > 0) {
      if ((this.data.NoOfPermanentEmployee == undefined || this.data.NoOfPermanentEmployee == null || this.data.NoOfPermanentEmployee == 0)) {
        this.toastr.error("Enter no of permanent employees");
        return
      }
    }
    if (this.data.TotalAdhocSalary > 0) {
      if ((this.data.NoOfAdhocEmployee == undefined || this.data.NoOfAdhocEmployee == null || this.data.NoOfAdhocEmployee == 0)) {
        this.toastr.error("Enter no of adhoc employees");
        return
      }
    }

    if (this.data.NoOfPermanentEmployee > 0 && (this.data.TotalPermanentSalary == null || this.data.TotalPermanentSalary == 0)) {
      this.toastr.error("Enter total salary of permanent employees");
      return
    }

    if (this.data.NoOfAdhocEmployee > 0 && (this.data.TotalAdhocSalary == null || this.data.TotalAdhocSalary == 0)) {
      this.toastr.error("Enter total salary of adhoc employees");
      return
    }

    var empType = null
    for (var i = 0; i < this.employeetypes.length; i++) {
      if (this.data.EmployeeTypeID == this.employeetypes[i]["value"]) {
        empType = this.employeetypes[i]["text"];
        break;
      }
    }

    if (parseInt(this.hid_EmployeeDetailID) >= 0) {
      this.EmployeeDetail[this.hid_EmployeeDetailID] = {
        "EmployeeTypeID": this.data.EmployeeTypeID, "EmployeeType": empType, "NoOfPermanentEmployee": this.data.NoOfPermanentEmployee
        , "NoOfAdhocEmployee": this.data.NoOfAdhocEmployee, "TotalPermanentSalary": this.data.TotalPermanentSalary, "TotalAdhocSalary": this.data.TotalAdhocSalary
      }
    }
    else {
      for (var i = 0; i < this.EmployeeDetail.length; i++) {
        if (this.data.EmployeeTypeID == this.EmployeeDetail[i]["EmployeeTypeID"]) {
          this.toastr.error("Employee category is already exists");
          return
        }
      }
      this.EmployeeDetail[this.EmployeeDetail.length] = {
        "EmployeeTypeID": this.data.EmployeeTypeID, "EmployeeType": empType, "NoOfPermanentEmployee": this.data.NoOfPermanentEmployee
        , "NoOfAdhocEmployee": this.data.NoOfAdhocEmployee, "TotalPermanentSalary": this.data.TotalPermanentSalary, "TotalAdhocSalary": this.data.TotalAdhocSalary
      }
    }
    this.clearEmployeeDetail();
  }

  editEmployeeDetail(i) {
    this.hid_EmployeeDetailID = i;
    this.data.EmployeeTypeID = this.EmployeeDetail[i]["EmployeeTypeID"];
    this.data.NoOfPermanentEmployee = this.EmployeeDetail[i]["NoOfPermanentEmployee"];
    this.data.NoOfAdhocEmployee = this.EmployeeDetail[i]["NoOfAdhocEmployee"];
    this.data.TotalPermanentSalary = this.EmployeeDetail[i]["TotalPermanentSalary"];
    this.data.TotalAdhocSalary = this.EmployeeDetail[i]["TotalAdhocSalary"];
  }

  deleteEmployeeDetail(i) {
    this.EmployeeDetail.splice(parseInt(i), 1);
  }

  clearEmployeeDetail() {
    this.hid_EmployeeDetailID = "-1";
    this.data.EmployeeTypeID = 0;
    this.data.NoOfPermanentEmployee = null;
    this.data.NoOfAdhocEmployee = null;
    this.data.TotalPermanentSalary = null;
    this.data.TotalAdhocSalary = null;
  }

  addInfrastructure() {
    if (this.data.InfrastructureID == undefined || this.data.InfrastructureID == 0) {
      this.toastr.error("Select infrastructure type");
      return
    }

    if (this.data.NoOfInfrastructure == undefined || this.data.NoOfInfrastructure == null || this.data.NoOfInfrastructure == 0) {
      this.toastr.error("Enter no of infrastructure");
      return
    }
    if (this.data.InfrastructureSize == undefined || this.data.InfrastructureSize == null || this.data.InfrastructureSize < 0) {
      this.toastr.error("Enter infrastructure size");
      return
    }

    var InfrastructureType = null
    for (var i = 0; i < this.infrastructures.length; i++) {
      if (this.data.InfrastructureID == this.infrastructures[i]["value"]) {
        InfrastructureType = this.infrastructures[i]["text"];
        break;
      }
    }

    if (parseInt(this.hid_InfrastructureDetailID) >= 0) {
      this.InfrastructureDetail[this.hid_InfrastructureDetailID] = {
        "InfrastructureID": this.data.InfrastructureID, "InfrastructureType": InfrastructureType, "NoOfInfrastructure": this.data.NoOfInfrastructure, "InfrastructureSize": this.data.InfrastructureSize
      }
    }
    else {
      for (var i = 0; i < this.InfrastructureDetail.length; i++) {
        if (this.data.InfrastructureID == this.InfrastructureDetail[i]["InfrastructureID"]) {
          this.toastr.error("Infrastructure type is already exists");
          return
        }
      }
      this.InfrastructureDetail[this.InfrastructureDetail.length] = {
        "InfrastructureID": this.data.InfrastructureID, "InfrastructureType": InfrastructureType, "NoOfInfrastructure": this.data.NoOfInfrastructure, "InfrastructureSize": this.data.InfrastructureSize
      }
    }
    this.clearInfrastructure();
  }

  editInfrastructure(i) {
    this.hid_InfrastructureDetailID = i;
    this.data.InfrastructureID = this.InfrastructureDetail[i]["InfrastructureID"];
    this.data.NoOfInfrastructure = this.InfrastructureDetail[i]["NoOfInfrastructure"];
    this.data.InfrastructureSize = this.InfrastructureDetail[i]["InfrastructureSize"];
  }

  deleteInfrastructure(i) {
    this.InfrastructureDetail.splice(parseInt(i), 1);
  }

  clearInfrastructure() {
    this.hid_InfrastructureDetailID = "-1";
    this.data.InfrastructureID = 0;
    this.data.NoOfInfrastructure = null;
    this.data.InfrastructureSize = null;
  }

  addEmployeeQualification() {
    if (this.data.QualificationID == undefined || this.data.QualificationID == 0) {
      this.toastr.error("Select qualification type");
      return
    }

    if (this.data.NoofEmployee == undefined || this.data.NoofEmployee == null || this.data.NoofEmployee == 0) {
      this.toastr.error("Enter no of employees");
      return
    }

    var QualificationType = null
    for (var i = 0; i < this.qualifications.length; i++) {
      if (this.data.QualificationID == this.qualifications[i]["value"]) {
        QualificationType = this.qualifications[i]["text"];
        break;
      }
    }

    if (parseInt(this.hid_EmployeeQualificationDetailID) >= 0) {
      this.EmployeeQualificationDetail[this.hid_EmployeeQualificationDetailID] = {
        "QualificationID": this.data.QualificationID, "Qualification": QualificationType, "NoofEmployee": this.data.NoofEmployee
      }
    }
    else {
      for (var i = 0; i < this.EmployeeQualificationDetail.length; i++) {
        if (this.data.QualificationID == this.EmployeeQualificationDetail[i]["QualificationID"]) {
          this.toastr.error("Qualification type is already exists");
          return
        }
      }
      this.EmployeeQualificationDetail[this.EmployeeQualificationDetail.length] = {
        "QualificationID": this.data.QualificationID, "Qualification": QualificationType, "NoofEmployee": this.data.NoofEmployee
      }
    }
    this.clearEmployeeQualification();
  }

  editEmployeeQualification(i) {
    this.hid_EmployeeQualificationDetailID = i;
    this.data.QualificationID = this.EmployeeQualificationDetail[i]["QualificationID"];
    this.data.NoofEmployee = this.EmployeeQualificationDetail[i]["NoofEmployee"];
  }

  deleteEmployeeQualification(i) {
    this.EmployeeQualificationDetail.splice(parseInt(i), 1);
  }

  clearEmployeeQualification() {
    this.hid_EmployeeQualificationDetailID = "-1";
    this.data.QualificationID = 0;
    this.data.NoofEmployee = null;
  }

  resetDropDown() {
    for (var i = 0; i < this.boards.length; i++) {
      $('#chkBoard' + i).prop("checked", false);
    }
    for (var i = 0; i < this.mediums.length; i++) {
      $('#chkmedium' + i).prop("checked", false);
    }
    for (var i = 0; i < this.sections.length; i++) {
      $('#chksection' + i).prop("checked", false);
    }
    for (var i = 0; i < this.institutetypes.length; i++) {
      $('#chkinstitute' + i).prop("checked", false);
    }
    this.data.Medium = "";
    this.data.Board = "";
    this.data.TypeOfTrust = 0;
    this.data.Section = "";
    this.data.Office = 0;
    this.data.InstituteTypeID = "";
  }
  redirectToList() {
    this.router.navigate(['/registrationlist']);
  }
  onlyDouble(evt, val) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    if (charCode == 46 && val != undefined && String(val).includes('.'))
      return false;
    var i = String(val).indexOf('.');
    if (i > 0 && String(val).length > i + 2)
      return false
    return true;
  }
  displayyear(i) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }
}
